export default {
    project_name: "Universidade Newell",
	register: 'CNPJ',
	company_agency: 'Profissão',
}